const module = { name: 'shared/global/jcarousel.swipe', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const HammerDirections = {
    DIRECTION_LEFT: 2,
}


let hasRun = false
function init() {
    if (hasRun) {
        return;
    }
    hasRun = true;
    $.fn.jcarouselSwipe = function (options) {
        options = $.extend({
            next: '+=1',
            prev: '-=1'
        }, options);
        return this.each(function () {
            const $this = $(this);
            const carousel = $this.data('jcarousel');
            $this.hammer();
            const hammerManager = $this.data('hammer');
            hammerManager.get('pan').set({ threshold: 20 });
            hammerManager.get('swipe').set({ velocity: 0.2 });
            $this.on('dragleft dragright swipeleft swiperight', (e) => {
                e.gesture.srcEvent.preventDefault();
                carousel.scroll(options[e.gesture.direction === HammerDirections.DIRECTION_LEFT ? 'next' : 'prev']);
            });
        });
    };
}
module.exports = {
    init,
};
export default module.exports;